import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@shared/utils/utils';
import React from 'react';

type FormSectionCardProps = {
  title: string;
  icon: IconDefinition;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  /** Acento izquierdo (misma pista que la acción en el listado de cliente) */
  accent?: 'left' | 'none';
};

/**
 * Sección de formulario alineada con el listado de reglas (cliente): tarjeta con cabecera en banda.
 */
export const FormSectionCard: React.FC<FormSectionCardProps> = ({
  title,
  icon,
  children,
  className,
  contentClassName,
  accent = 'none',
}) => {
  return (
    <section
      className={cn(
        'overflow-hidden rounded-lg border border-border bg-card text-card-foreground',
        accent === 'left' && 'border-l-[3px] border-l-primary/45',
        className,
      )}
    >
      <div className="border-b border-border bg-muted/30 px-3 py-2.5 sm:px-4">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <FontAwesomeIcon icon={icon} className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
          {title}
        </h2>
      </div>
      <div className={cn('space-y-3 p-3 sm:p-4', contentClassName)}>{children}</div>
    </section>
  );
};
